var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(46.3555 46.7734) rotate(-180)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9177",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "46.3555",
              y: "46.7734",
              width: "46",
              height: "46",
              rx: "6",
              transform: "rotate(-180 46.3555 46.7734)",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9177)" } }, [
        _c("path", {
          attrs: {
            d: "M0.370792 46.7734H46.3555V0.773438H0.370792V46.7734Z",
            fill: "#F47277",
          },
        }),
        _c("path", {
          attrs: {
            d: "M36 50.1914H-3.11775V11.3309C18.4857 11.3309 36 28.73 36 50.1914Z",
            fill: "#E93338",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }